import React                   from 'react'
import { connect }             from 'react-redux'

import Formsy from 'formsy-react';
import i18n from '../../i18n';
import Select from '../forms/Select';

import DatePicker from '../forms/DatePicker';
import {DateHelper} from '../../util/date-helper'
import ToastHelper from '../../util/toast-helper'

import {mapDispatchToProps} from "../mapDispatchToProps"
import withBaseComponent from '../withBaseComponent';
import axios from 'axios';
import {apiUrl} from "../../actions/config";
import {hasPaymentSupport} from "../../util/payment-helper";
import NoticeModal from '../common/NoticeModal'
import CheckBox from '../forms/CheckBox';
import { trackingEvent } from "./layouts/GoogleAnalytics.js"

class Csv extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props);
    this.state = {
      account: null,
      encoding: "shift-jis",
      isOpenModal: false,
      isOpenNoSubAccountModal: false
    };

    this.renderCsvFile = this.renderCsvFile.bind(this);
    this.handleDownloadError = this.handleDownloadError.bind(this);
    this.trackingSelectUnicode = this.trackingSelectUnicode.bind(this)
    this.trackingSelectAccount = this.trackingSelectAccount.bind(this)
    this.trackingSelectSubAccount = this.trackingSelectSubAccount.bind(this)
  }

  handleAccountChange(id) {
    this.trackingSelectAccount()
    if (id === "")
      return this.setState({account: id})
    this.props.accountActions.subAccountList(id).then(() => this.setState({account: id}))
  }

  componentWillMount() {
    this.props.accountActions.accountList()
  }

  accountOptions() {
    if(!this.props.accountList)
      return []

    let options = [{value: "", title: i18n.t('csv.placeholder.account_dropdown')}]
    this.props.accountList.forEach(account => {
      options.push({value: account.id, title: account.display_name && account.display_name.substring(0, 50)})
    })

    return options
  }

  subAccountOptions() {
    if(this.state.account < 1 || this.props.accountList.size === 0)
      return []
    const account = this.props.accountList.find(ac => ac.id === this.state.account)
    let options = [{value: "", title: i18n.t('csv.placeholder.sub_account_dropdown')}]

    account.sub_accounts && account.sub_accounts.sub_accounts.forEach(subAccount => {
      if (subAccount.is_target) {
        const title = ["name", "type", "number"].map(item => subAccount[item]).join(" ")
        options.push({value: subAccount.id, title: title})
      }
    })

    return options
  }

  encodingOptions() {
    return [
      {value: "", title: i18n.t('csv.placeholder.encoding')},
      {value: "utf-8", title: i18n.t('csv.character_encoding.utf8')},
      {value: "shift-jis", title: i18n.t('csv.character_encoding.shiftjis')}
    ]
  }

  onSubmit(model) {
    trackingEvent("CSV", "CVSダウンロード")
    if (this.hasError())
      return
    // Case there are not sub account options : display error message
    let subAccountOptions = this.subAccountOptions()
    if (subAccountOptions.length <= 1) {
      this.setState({isOpenNoSubAccountModal: true})
      return
    }

    this.setState({encoding: model["encoding"]})

    let account = this.props.accountList.find(ac => ac.id === this.state.account)
    if (hasPaymentSupport(account.service_id))
      model["has_payment"] = true
    this.renderCsvFile(this.correctParams(model))
  }

  closeErrorMessage() {
    this.setState({isOpenNoSubAccountModal: false})
    return
  }

  correctParams(model) {
    return {
      account_ids: [model["account_id"]],
      sub_account_ids: [model["sub_account_id"]],
      from_date: model["from_date"],
      to_date: model["to_date"],
      has_payment: model["has_payment"],
      encoding: model["encoding"],
      custom_format: model["custom_format"]
    }
  }

  triggerClick() {
    if (this.props.transactions.amount <= 0) {
      ToastHelper.message({status: "warning", message: i18n.t('csv.message.no_data')})
      return
    }

    const filename = this.props.transactions.file_name
    axios.get(`${apiUrl}client/download`, {
      params: { filename },
      responseType: 'blob'
    }).then((response) => {
      const contentType = response.headers['content-type'] || 'text/csv'
      const blob = new Blob([response.data], { type: contentType })
      const objectUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = objectUrl
      link.download = 'transaction.csv'
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(objectUrl)
    }).catch(this.handleDownloadError)
  }

  handleDownloadError(response) {
    if (!response) {
      ToastHelper.message({status: "error", message: i18n.t('csv.message.download_failed')})
      return
    }
    if (response.status === 404 && response.data instanceof Blob) {
      response.data.text().then((text) => {
        let message = i18n.t('csv.message.download_failed')
        try {
          const body = JSON.parse(text)
          if (typeof body.errors === 'string') {
            message = body.errors
          } else if (body.errors && body.errors[0] && body.errors[0].message) {
            message = body.errors[0].message
          }
        } catch (_e) {
          /* keep default message */
        }
        ToastHelper.message({status: "warning", message})
      }).catch(() => {
        ToastHelper.message({status: "warning", message: i18n.t('csv.message.download_failed')})
      })
      return
    }
    ToastHelper.message({status: "error", message: i18n.t('csv.message.download_failed')})
  }

  renderCsvFile(conditions) {
    this.props.userActions.transactions(conditions)
      .then(() => this.triggerClick())
      .catch(error => {
        if(error.data.errors[0].message === 'over'){
          this.setState({isOpenModal: true})
          return
        }
      })
  }

  trackingSelectUnicode() {
    trackingEvent("CSV", "文字コードを選択")
  }

  trackingSelectAccount() {
    trackingEvent("CSV", "対象金融機関を指定")
  }

  trackingSelectSubAccount() {
    trackingEvent("CSV", "対象ロ座を指定")
  }

  render() {
    return (
      <div className="bank-container small-container" id="csv-container">
        <div className="row no-gutters">
          <div className="col-sm-12 title">
            <div className="float-left">{i18n.t("csv.title.page")}</div>
          </div>
        </div>
        <div className="no-gutters">
          <div className="col-sm-12 content-body">
            <Formsy onChange={() => this.resetFromDateError()} ref="form" className="form" onInvalidSubmit={this.showErrors} onSubmit={(model) => this.onSubmit(model)} onValid={this.enableButton} onInvalid={this.disableButton}>
              <div className="row form-group form-inline">
                <label className="col-sm-3" htmlFor="frm-title">{i18n.t('csv.label.encoding')} </label>
                <div className="form-group">
                  <Select
                    options={this.encodingOptions()}
                    name="encoding"
                    classNameSelect="normal-width"
                    validations="isExisty"
                    validationError={i18n.t('csv.message.encoding')}
                    required
                    defaultMessage={false}
                    onChange={this.trackingSelectUnicode}
                  />
                </div>
              </div>
              <hr/>
              <div className="row form-group form-inline">
                <label className="col-sm-3" htmlFor="frm-title">{i18n.t('csv.label.datepicker')} </label>
                <div className="col-sm-9 form-group mfc-box-calendar">
                  <DatePicker className="normal-width" classDatePicker="normal-width"
                    startDate={DateHelper.startOfCurrentMonth()} name="from_date" required dateFormat={"yyyy/MM/dd"} isCsv={true} />
                  <span className="separate">~</span>
                  <DatePicker className="normal-width" classDatePicker="normal-width"
                    startDate={DateHelper.endOfCurrentMonth()} name="to_date" required dateFormat={"yyyy/MM/dd"} isCsv={true}/>
                </div>
              </div>
              <hr/>
              <div className="row form-group form-inline">
                <label className="col-sm-3" htmlFor="frm-title">{i18n.t('csv.label.account_dropdown')} </label>
                <div className="form-group">
                  <Select
                    options={this.accountOptions()}
                    onChange={(id) => this.handleAccountChange(id)}
                    name="account_id"
                    classNameSelect="large-width"
                    validations="isExisty"
                    validationError={i18n.t('validations.csv.noAccount')}
                    defaultMessage={false}
                    required />
                </div>
              </div>
              <hr/>
              {this.state.account && <div className="row form-group form-inline">
                <label className="col-sm-3" htmlFor="frm-title">{i18n.t('csv.label.sub_account_dropdown')} </label>
                <div className="form-group ">
                  <Select
                    options={this.subAccountOptions()}
                    name="sub_account_id"
                    classNameSelect="large-width" onChange={this.trackingSelectSubAccount}/>
                </div>
              </div>}
              {this.state.account && <hr/>}
              <div className="row form-group form-inline">
                <label className="col-sm-3" htmlFor="frm-title">{i18n.t('csv.label.custom_format')} </label>
                <div className="form-group">
                  <CheckBox label={i18n.t('csv.title.custom_format')} id="custom_format" name="custom_format" />
                </div>
              </div>
              <hr/>
              <div className="row form-group form-inline download-csv-footer">
                <button className="btn btn-csv btn-md" type="submit"><i className="fas fa-file-download"></i>  {i18n.t('csv.label.csv_btn')}</button>
              </div>
            </Formsy>
          </div>
        </div>
        <NoticeModal
          isOpen={this.state.isOpenModal}
          toggle={this.toggleModal}
          title={i18n.t('csv.over_modal.title')}
          body={i18n.t('csv.over_modal.msg')}
        />
        <NoticeModal
          isOpen={this.state.isOpenNoSubAccountModal}
          toggle={() => {this.closeErrorMessage()}}
          title={i18n.t('csv.no_data.title')}
          body={i18n.t('csv.no_data.msg')}
        />
      </div>
      )
  }
}

function mapStateToProps(state) {
  return {
    accountList: state.user.get('accounts'),
    transactions: state.user.get('transactions')
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Csv)
